import 'select2';
import * as select2 from 'select2';

const topbarSelect = {

	init: function() {

		(typeof select2 == 'function') ? select2($) : null;

		// Functie die de options van de topbar selects laad
		var topbarSelect = document.getElementsByClassName('topbar-select');
		if (topbarSelect !== undefined) {
			for (var i = 0; i < topbarSelect.length; i++) {
				topbarSelect[i].onchange = function() {
					if (this.value != '') {
						var elementName = this.id.replace('topbar_', '');
						document.location.href = '?' + elementName + '=' + this.value;
					}
				};
			}
		}

		// Functie die de value van de select als windows.location.href laadt
		var elementList = document.querySelectorAll('[data-select-link]');
		if (elementList !== undefined) {
			for (var i = 0; i < elementList.length; i++) {
				elementList[i].onchange = function() {
					if (this.value != '') {
						document.location.href = this.value;
					}
				};
			}
		}

		// Init select2
		$('#topbar_company, #topbar_tussenp, #topbar_group, #topbar_user').select2({
			theme: 'bootstrap-5',
			ajax: {
				quietMillis: 1000, // wait 1000 milliseconds before triggering the request
				delay: 1000, // wait 1000 milliseconds before triggering the request
				dataType: 'json',
				minimumInputLength: 2,
				url: '/select2/json/',
				data: function(params) {
					var query = {
						search: params.term,
						type: $(this).attr('id'),
						page: params.page || 1
					};
					// Query parameters will be ?search=[term]&type=public
					return query;
				},
				processResults: function(data) {
					return data;
				},
			}
		});

		// Init select2 multiple
		$('#topbar_team').select2({
			theme: 'bootstrap-5'
		});

	}

};

export default topbarSelect;
